import request from '@/utils/request';

// 详情
export async function getDetail(params) {
  return request.get('nxin.information.help.get/1.0', {
    params,
  });
}

// 是否有用
export async function putInvestigate(params) {
  return request.get('nxin.information.help.resolved/1.0', {
    params,
  });
}
